import base from '../dr-base'
import drTab from './dr-tab.vue'
//test
const schema = {
  $Type: 'dr-tab',
  name: 'Tab',
  group: 'Container widgets',
  allowInToolbox: false,
  properties: {
    ...base.properties,
    Widgets: {
      type: 'array',
      items: {
        type: 'object'
      }
    },
    Text: {
      name: 'vuetifyWidgets.dr-tabs.text',
      type: 'string',
      default: 'Text'
    },
    IconName: {
      name: 'vuetifyWidgets.dr-button.iconName',
      type: 'string',
      default: '',
      component: 'dr-icon-picker'
    },
    IconColor: {
      name: 'vuetifyWidgets.dr-button.iconName',
      type: 'string',
      default: '#2196f3',
      component: 'dr-color-picker'
    }
  }
}

export default {
  schema,
  component: drTab,
  propEditors: [
    {
      name: 'dr-icon-picker'
    },
    {
      name: 'dr-color-picker'
    }
  ]
}
